import { render, staticRenderFns } from "./youtube-embed.vue?vue&type=template&id=396cd022&"
import script from "./youtube-embed.vue?vue&type=script&lang=js&"
export * from "./youtube-embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports